import {OrganizationDetailsReqRes} from 'src/app/account/my-account/model/OrganizationDetailsReqRes.model';
import {GpHoldingListItemReqRes} from 'src/app/dashboard/shared/holding/GpHoldingListItem.model';
import {PhoneVerificationReqRes} from '../../components/phone-verification-dialog/PhoneVerificationReqRes.model';
import {UnitApplicationParentType} from '../../enums/unit-bank-account/UnitApplicationParentType.enum';
import UnitApplicationStatus from '../../enums/unit-bank-account/UnitApplicationStatus.enum';
import {UnitBankAccountReqRes} from '../../models/gp/UnitBankAccountReqRes.model';
import {UnitAddress} from './UnitAddress.model';
import {UnitBeneficialOwnerReqRes} from './UnitBeneficialOwnerReqRes.model';
import {UnitBusinessContact} from './UnitBusinessContact.model';
import {UnitDocumentReqRes} from './UnitDocumentReqRes.model';
import {UnitOfficer} from './UnitOfficer.model';
import {UnitPhone} from './UnitPhone.model';
import {UnitBusinessVertical} from '../../enums/unit-bank-account/UnitBusinessVertical.enum';
import {UnitNumberOfEmployees} from '../../enums/unit-bank-account/UnitNumberOfEmployees.enum';
import {UnitBusinessAnnualRevenue} from '../../enums/unit-bank-account/UnitBusinessAnnualRevenue.enum';

export class UnitBusinessApplicationReqRes {
  public id: number;

  public parentType: UnitApplicationParentType;

  public clientDetailsId?: number;

  public organization: OrganizationDetailsReqRes;

  public holdingId?: number;

  public companyDetailsId?: string;

  public holding: GpHoldingListItemReqRes;

  public company: string;

  public unitCustomerId: number;

  public status: UnitApplicationStatus;

  public createdAtUnit: Date;

  /** Name of the business.  */
  public name: string;

  /** Doing business as */
  public dba: string;

  /** Bank Account Name */
  public bankAccountName: string;

  /** Address of the business. */
  public address: UnitAddress;

  /** Phone number of the business. */
  public phone: UnitPhone;

  /** Two letters representing a US state. */
  public stateOfIncorporation: string;

  /** Business EIN (numbers only). */
  public ein: string;

  /** One of "Corporation", "LLC" or "Partnership" */
  public entityType: string;

  /** Business's website. Optional. */
  public website: string;

  public notHaveWebsite: boolean;

  /** Primary contact of the business. */
  public contact: UnitBusinessContact;

  /**
   * Officer representing the business (must be the CEO, COO, CFO, President or BenefitsAdministrationOfficer).
   * To onboard a business successfully, you must provide the officer's personal details.
   */
  public officer: UnitOfficer;

  /**
   * List of beneficial owners in the business. Beneficial owners are all people that, directly or indirectly,
   * own 25% or more of the business. To onboard a business successfully, you must provide each beneficial owner's personal details.
   */
  public beneficialOwners: UnitBeneficialOwnerReqRes[];

  public documents: UnitDocumentReqRes[];

  /** Tags that will be copied to the customer that this application creates. */
  public tags: Map<string, string>;

  /** Covercy field */
  public phoneVerification: PhoneVerificationReqRes;

  public bankAccounts: UnitBankAccountReqRes[];

  public businessVertical: UnitBusinessVertical;

  public yearOfIncorporation: number;

  public annualRevenue: UnitBusinessAnnualRevenue;

  public numberOfEmployees: UnitNumberOfEmployees;

  public countriesOfOperation: string[];

  public cashFlow: string;
}
